import { Box, IconButton, Paper, Stack, Typography, useTheme } from "@mui/material";
import placeholder from "@/assets/placeholder.png";
import transparency from "@/assets/images/transparent-bg.jpg";
import { Trash2, Upload } from "lucide-react";
import { useDropzone } from "react-dropzone";

interface Props {
    label?: string;
    value: File | null;
    onChange: (file: File | null) => void
}

const ImageUpload = ({ label, value, onChange,  }: Props) => {
    const { palette } = useTheme();

    const {getRootProps, getInputProps, open } = useDropzone({
        maxFiles: 1,
        noClick: true,
        noKeyboard: true,
        accept: {
            'image/*': ['.png', '.jpg', '.jpeg']
        },
        onDrop: (acceptedFiles) => {
            onChange(acceptedFiles[0] ?? null);
        }
    });

    const onRemoveFile = () => {
        onChange(null);
    }

    return (
        <div {...getRootProps({className: 'dropzone'})}>
            <input {...getInputProps()} />
            <Stack spacing={2} className="image-upload">
                {label ? (
                    <Typography variant="h4">{label}</Typography>
                ) : null}
                <Paper
                    sx={{
                        borderRadius: 2,
                        overflow: 'hidden',
                    }}
                >
                    <Box
                        sx={{
                            backgroundImage: `url(${transparency})`,
                            backgroundRepeat: 'no-repeat',
                            backgroundPosition: 'center',
                        }}
                    >
                        <Box
                            width="100%"
                            height={150}
                            sx={{
                                minWidth: 200,
                                maxWidth: '100%',
                                backgroundImage: `url(${value ? URL.createObjectURL(value) : placeholder})`,
                                backgroundSize: '70% auto',
                                backgroundRepeat: 'no-repeat',
                                backgroundPosition: 'center',
                                backgroundColor: value ? 'transparent' : '#d1d1d1',
                                boxShadow: 'inset 0 -2px 2px rgba(0,0,0,0.25)'
                            }}
                        />
                    </Box>
                    <Stack direction="row" alignItems="center" paddingX={2} paddingY={1} justifyContent="space-between">
                        {value ? (
                            <Typography>{(value.size / 1024).toFixed(2)} KB</Typography>
                        ) : (
                            <Typography>Cargar</Typography>
                        )}

                        {value ? (
                            <IconButton onClick={onRemoveFile}>
                                <Trash2 color={palette.primary.main}/>
                            </IconButton>
                        ) : (
                            <IconButton onClick={open}>
                                <Upload color={palette.primary.main}/>
                            </IconButton>
                        )}
                    </Stack>
                </Paper>
            </Stack>
        </div>
    )
}

export default ImageUpload;
